/* eslint-disable func-names */
import React from 'react';
import { Column } from 'rbx';
import styled from 'styled-components';
import { withFormik } from 'formik';
import * as yup from 'yup';
import { forEach } from 'lodash';

import { Input } from '../../../components/elements';
import ApiActionTypeInput from '../Utils/ApiActionTypeInput';
import PageActionTypeInput from '../Utils/PageActionTypeInput';

yup.addMethod(yup.string, 'testNonNegativeValue', function(errorMessage) {
  return this.test(`test-non-negative-value`, errorMessage, function(value) {
    const { path, createError } = this;
    const num = +value;

    return num >= 0 || createError({ path, message: errorMessage });
  });
});

const Container = styled.div`
  &&& {
    z-index: 2000;
    .modal-background {
      background-color: rgba(13, 13, 13, 0.28);
    }
    .modal-card-body {
      height: 80vh;
      padding: 0rem 1rem;
    }
    .modal-card {
      max-height: calc(100vh - 140px);
      position: absolute;
      width: 40rem;
    }
    .modal-card-head,
    .modal-card-foot {
      border-top-left-radius: 0px;
      border-top-right-radius: 0px;
    }
    .modal-card-title {
      font-size: 1.5rem;
      font-weight: 600;
    }
    .modal-card-head {
      border-bottom: 0px;
      padding: 1.5rem 1rem;
      background: white;
    }
    .modal-card-foot {
      justify-content: flex-end;
      border: 0px;
      padding: 1rem;
      background: white;
    }
    a {
      font-size: 1rem;
    }
  }
`;

const parseData = parseValue => {
  const final = [];
  forEach(parseValue, item => {
    final.push({ value: item, label: item.name });
  });
  return final;
};

const parseInput = parseValue => {
  const final = [];
  forEach(parseValue, item => {
    final.push(item.value);
  });
  return final;
};

const Form = props => {
  const {
    isActive,
    onClose,
    setFieldValue,
    values,
    handleSubmit,
    loading,
    touched,
    errors,
    acl,
  } = props;

  const [isJsonView, setIsJsonView] = React.useState(false);

  return (
    <Container className={`modal ${isActive && 'is-active'}`}>
      <div className="modal-background" />
      <div className="modal-card">
        <header className="modal-card-head">
          <p className="modal-card-title">Acls</p>
          <button
            type="button"
            className="delete"
            aria-label="close"
            onClick={isJsonView ? () => setIsJsonView(false) : () => onClose()}
          />
        </header>
        <section className="modal-card-body">
          {isJsonView ? (
            <pre style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
              {JSON.stringify(acl, null, 2)}
            </pre>
          ) : (
            <>
              <Column.Group gapSize={8} multiline vcentered>
                <Column size="half">
                  <Input
                    label="Name"
                    value={values.name}
                    onChange={event =>
                      setFieldValue(`name`, event.target.value)
                    }
                    required
                    errors={errors.name}
                    touched={touched.name}
                    disableToastMessage
                  />
                </Column>
                <Column size="half">
                  <Input
                    label="Description"
                    value={values.description}
                    onChange={event =>
                      setFieldValue(`description`, event.target.value)
                    }
                    required
                    errors={errors.description}
                    touched={touched.description}
                    disableToastMessage
                  />
                </Column>
              </Column.Group>
              <br />
              <div>
                <PageActionTypeInput
                  label="Page Actions"
                  id="Page_Actions"
                  value={parseData(values.page_actions)}
                  onChange={value =>
                    setFieldValue('page_actions', parseInput(value))
                  }
                />
              </div>
              <br />
              <div>
                <ApiActionTypeInput
                  label="Api Actions"
                  id="Api_Actions"
                  value={parseData(values.api_actions)}
                  onChange={value =>
                    setFieldValue('api_actions', parseInput(value))
                  }
                />
              </div>
            </>
          )}
        </section>

        <footer className="modal-card-foot">
          {acl && (
            <>
              {isJsonView ? (
                <button
                  type="button"
                  className="button"
                  onClick={() => setIsJsonView(false)}
                >
                  View Form
                </button>
              ) : (
                <button
                  type="button"
                  className="button"
                  onClick={() => setIsJsonView(true)}
                >
                  View JSON
                </button>
              )}
            </>
          )}
          <button type="button" className="button" onClick={onClose}>
            cancel
          </button>
          <button
            type="button"
            className={`button is-primary ${loading && 'is-loading'}`}
            onClick={handleSubmit}
          >
            Save
          </button>
        </footer>
      </div>
    </Container>
  );
};

const AddEditForm = withFormik({
  mapPropsToValues: ({ acl }) => ({
    name: acl ? acl.name : '',
    description: acl ? acl.description : '',
    api_actions:
      acl && acl.api_actions && Array.isArray(acl.api_actions)
        ? acl.api_actions
        : [],
    page_actions:
      acl && acl.page_actions && Array.isArray(acl.page_actions)
        ? acl.page_actions
        : [],
  }),

  validationSchema: yup.object().shape({
    name: yup
      .string()
      .nullable('Name is required!')
      .min(3, 'Please enter at least 3 characters')
      .max(50, 'Please enter less than 20 characters')
      .required('Name is required!'),
    description: yup
      .string()
      .nullable('Description is required!')
      .min(3, 'Please enter at least 3 characters')
      .max(50, 'Please enter less than 20 characters')
      .required('Description is required!'),
  }),

  handleSubmit: (values, { props }) => {
    props.onSubmit({
      name: values.name,
      description: values.description,
      api_actions: values.api_actions.map(ele => ele.api_action_id),
      page_actions: values.page_actions.map(ele => ele.page_action_id),
    });
  },
  enableReinitialize: true,
  displayName: 'AddEditForm',
})(Form);

export default AddEditForm;
